import { PaginationSchema } from '@visep/shared-types/common';
import type { Pagination } from '@visep/shared-types/common';
import {
  CombustibleStatsSchema,
  CreateGastoCombustibleRequestSchema,
  CreateVehiculoRequestSchema,
  FlotaStatsSchema,
  GastoCombustibleListQuerySchema,
  GastoCombustibleSchema,
  UpdateGastoCombustibleRequestSchema,
  UpdateVehiculoRequestSchema,
  VehiculoListQuerySchema,
  VehiculoOptionSchema,
  VehiculoSchema,
} from '@visep/shared-types/flota';
import type { CombustibleStats, FlotaStats, VehiculoOption } from '@visep/shared-types/flota';
import type { Helpers, ListResult } from './internal.js';
import { listResultSchema, makeCrudResource, toQuery } from './internal.js';

export function createFlotaResource({ request, requestMultipart }: Helpers) {
  const vehiculos = makeCrudResource(request, {
    basePath: '/api/vehiculos',
    schema: VehiculoSchema,
    listQuerySchema: VehiculoListQuerySchema,
    createSchema: CreateVehiculoRequestSchema,
    updateSchema: UpdateVehiculoRequestSchema,
  });
  const gastos = makeCrudResource(request, {
    basePath: '/api/combustible',
    schema: GastoCombustibleSchema,
    listQuerySchema: GastoCombustibleListQuerySchema,
    createSchema: CreateGastoCombustibleRequestSchema,
    updateSchema: UpdateGastoCombustibleRequestSchema,
  });
  return {
    async statsFlota(): Promise<FlotaStats> {
      return FlotaStatsSchema.parse(await request('GET', '/api/vehiculos/stats'));
    },
    async statsCombustible(): Promise<CombustibleStats> {
      return CombustibleStatsSchema.parse(await request('GET', '/api/combustible/stats'));
    },
    async uploadVehiculoFoto(id: string, file: Blob | File): Promise<{ imagenUrl: string | null }> {
      const form = new FormData();
      form.append('file', file, file instanceof File ? file.name : 'foto');
      return (await requestMultipart(`/api/vehiculos/${encodeURIComponent(id)}/foto`, form)) as {
        imagenUrl: string | null;
      };
    },
    // F9: shape mínimo p/ dropdowns cross-módulo (guard só-autenticado).
    async optionsVehiculos(query?: Pagination): Promise<ListResult<VehiculoOption>> {
      const parsed = query ? PaginationSchema.parse(query) : undefined;
      return listResultSchema(VehiculoOptionSchema).parse(
        await request('GET', `/api/vehiculos/options${parsed ? toQuery(parsed) : ''}`),
      );
    },
    listVehiculos: vehiculos.list,
    getVehiculo: vehiculos.get,
    createVehiculo: vehiculos.create,
    updateVehiculo: vehiculos.update,
    deleteVehiculo: vehiculos.delete,
    listGastos: gastos.list,
    getGasto: gastos.get,
    createGasto: gastos.create,
    updateGasto: gastos.update,
    deleteGasto: gastos.delete,
  };
}
